import { createContext, useContext } from "react";

export interface SelectItem {
  id: number;
  parentId: number | null;
  investorId?: number;
}

type SelectItemTypes = "folders" | "forms" | "files" | "documents";

export type ISelectState = Record<SelectItemTypes, SelectItem[]>;

export type SelectMode = "template" | "tagger" | null;

export interface SelectItemData {
  key: keyof ISelectState;
  item: SelectItem;
}

export type IsSelected = ({ key, id }: { key: keyof ISelectState; id: number }) => boolean;

export interface ISelectContext {
  state: ISelectState;
  selectMode: SelectMode;
  isSelectedAll: boolean;
  selectItem: (data: SelectItemData) => void;
  setSelectMode: React.Dispatch<React.SetStateAction<SelectMode>>;
  cancel: () => void;
  isSelected: IsSelected;
  selectAll: () => void;
  submit: () => void;
}

export const SelectContext = createContext<ISelectContext>({} as ISelectContext);

export const useSelectContext = (): ISelectContext => useContext(SelectContext);
